<template>
  <v-container>
    <v-card max-width="500" class="mx-auto">
      <v-toolbar class="white--text" :color="colors">
        <v-toolbar-title v-html="titiles"></v-toolbar-title>
        <v-spacer></v-spacer>

        <v-icon color="white">mdi-cash</v-icon>
      </v-toolbar>

      <v-list subheader>
        <v-subheader>{{ SubTitle }}</v-subheader>
        <v-list-item v-if="isLoading">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="subtitle-1 text-center" cols="12">
              Calculating please wait
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                color="deep-purple accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-list-item>

        <v-list-item v-if="TotalCash.length == 0 && !isLoading">
          <v-list-item-content>Empt Balance</v-list-item-content>
        </v-list-item>

        <v-list-item v-for="item in TotalCash" :key="item.title">
          <v-list-item-avatar size="34" class="white--text" :color="colors">
            {{ item.AmountType }}
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{
              item.Amount.toLocaleString()
            }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-icon>
            {{ item.AmountType | MoneySigns }}
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-card>
  </v-container>
</template>
<script>
export default {
  props: {
    TotalCash: { type: [Array], required: true },
    isLoading: { type: Boolean },
    Title: { type: String, required: true },
    SubTitle: { type: String, required: true },
  },
  computed: {
    colors() {
      if (this.Title === "Payable Cash") return "pink lighten-3";
      else if (this.Title === "Receivable Cash") return "red";
      else return "green";
    },
    titiles() {
      if (this.Title === "Payable Cash")
        return "Payable Cash <spam class='black--text'>(Amaanada)</spam>";
      else if (this.Title === "Receivable Cash")
        return "Receivable Cash <spam class='black--text'>(Deymaha)</spam>";
      else return "Cash On Hand <spam class='black--text'>(Khasnada)</spam>";
    },
  },
};
</script>
